/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { Link, useHistory } from 'react-router-dom';
import {
	Button,
	Card,
	CardBody,
	FormGroup,
	Form,
	Input,
	// InputGroupAddon,
	InputGroupText,
	InputGroup,
	Col,
	Spinner,
} from 'reactstrap';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../Redux/actions/authAction';

const Login = () => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const { loading } = useSelector(state => state.auth);
	const dispatch = useDispatch();
	const history = useHistory();
	return (
		<>
			<Col lg='5' md='7'>
				<Card className='bg-secondary shadow border-0'>
					<CardBody className='px-lg-5 py-lg-5'>
						<div className='text-center text-muted mb-4'>
							<small>Sign in with credentials</small>
						</div>
						<Form
							role='form'
							onSubmit={e => {
								e.preventDefault();
								let obj = { email, password };
								dispatch(login(obj, history));
							}}
						>
							<FormGroup className='mb-3'>
								<InputGroup className='input-group-alternative'>
									{/* <InputGroupAddon addonType='prepend'> */}
									<InputGroupText>
										<i className='ni ni-email-83' />
									</InputGroupText>
									{/* </InputGroupAddon> */}
									<Input
										placeholder='Email'
										type='email'
										autoComplete='new-email'
										onChange={e => setEmail(e.target.value)}
										required
									/>
								</InputGroup>
							</FormGroup>
							<FormGroup>
								<InputGroup className='input-group-alternative'>
									{/* <InputGroupAddon addonType='prepend'> */}
									<InputGroupText>
										<i className='ni ni-lock-circle-open' />
									</InputGroupText>
									{/* </InputGroupAddon> */}
									<Input
										placeholder='Password'
										type='password'
										autoComplete='new-password'
										onChange={e =>
											setPassword(e.target.value)
										}
										required
									/>
								</InputGroup>
							</FormGroup>
							<div className='text-center'>
								{/* <Link to='/admin/index'> */}
								<Button
									className='my-4'
									color='primary'
									type='submit'
								>
									{loading ? <Spinner /> : 'Sign in'}
								</Button>
								{/* </Link> */}
							</div>
						</Form>
					</CardBody>
				</Card>
				{/* <Row className='mt-3'>
					<Col xs='6'>
						<a
							className='text-light'
							href='#pablo'
							onClick={e => e.preventDefault()}
						>
							<small>Forgot password?</small>
						</a>
					</Col>
					<Col className='text-right' xs='6'>
						<a
							className='text-light'
							href='#pablo'
							onClick={e => e.preventDefault()}
						>
							<small>Create new account</small>
						</a>
					</Col>
				</Row> */}
			</Col>
		</>
	);
};

export default Login;
